import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAdfoxPuids } from 'shared/types/adfox';

const initialState: TAdfoxPuids = {};

export const adfoxPuidsSlice = createSlice({
  name: 'adfoxPuids',
  initialState,
  reducers: {
    setAdfoxPuids: (_, action: PayloadAction<TAdfoxPuids>) => action.payload,
  },
});

export const {
  reducer: adfoxPuidsReducer,
  name: adfoxPuidsReducerName,
  actions: { setAdfoxPuids },
} = adfoxPuidsSlice;
